// File: src/components/CalendarView/CalendarEventItem.js
import React from 'react';
import { Clock } from 'lucide-react';
import { format } from 'date-fns';

const CalendarEventItem = ({ event }) => {
  const startTime = event.start.dateTime 
    ? format(new Date(event.start.dateTime), 'HH:mm')
    : '';

  return (
    <div 
      className="text-xs p-2 rounded bg-violet-100 text-violet-700 mb-1 cursor-pointer hover:bg-violet-200 transition-colors"
      title={event.summary}
    >
      <div className="flex items-center">
        {startTime && (
          <>
            <Clock className="w-3 h-3 mr-1" />
            <span className="mr-1">{startTime}</span>
          </>
        )}
      </div>
      <div className="truncate">{event.summary}</div>
    </div>
  );
};

export default CalendarEventItem;